import { IconBaseProps } from "react-icons";
// Explicit imports only — a namespace import (`import * as`) of an icon set
// defeats tree-shaking and bundles the ENTIRE library (~1.7 MB parsed for
// hi + fa6, of which the app used 16 icons). TypeScript enforces the list:
// passing an unmapped name to <Icon icon=...> is a compile error.
import {
  HiCheckCircle,
  HiChevronLeft,
  HiExclamation,
  HiExclamationCircle,
  HiInformationCircle,
  HiLocationMarker,
  HiMail,
  HiOfficeBuilding,
  HiOutlineArrowsExpand,
  HiOutlineCalendar,
  HiOutlineChevronDown,
  HiOutlineChevronUp,
  HiOutlineExclamation,
  HiOutlineExternalLink,
  HiTruck,
  HiX,
} from "react-icons/hi";

import { TMargin, TTextColor } from "tw-generated";
import { tw } from "utils/tw";

import * as MMIcons from "./icons";

const HiIcons = {
  HiCheckCircle,
  HiChevronLeft,
  HiExclamation,
  HiExclamationCircle,
  HiInformationCircle,
  HiLocationMarker,
  HiMail,
  HiOfficeBuilding,
  HiOutlineArrowsExpand,
  HiOutlineCalendar,
  HiOutlineChevronDown,
  HiOutlineChevronUp,
  HiOutlineExclamation,
  HiOutlineExternalLink,
  HiTruck,
  HiX,
};

type HiIcon = keyof typeof HiIcons;
type MMIcon = keyof typeof MMIcons;
export type IconType = HiIcon | MMIcon;

interface Props extends Omit<IconBaseProps, "className"> {
  icon: IconType;
  isFilled?: boolean;
  color?: TTextColor;
  margin?: TMargin;
}

export default ({
  icon,
  isFilled = !/Outline|Mm/.test(icon),
  strokeWidth = isFilled ? 0 : 1.5,
  color,
  margin,
  ...iconProps
}: Props): React.JSX.Element | null => {
  const isHeroIcon = Object.prototype.hasOwnProperty.call(HiIcons, icon);
  const Icon = isHeroIcon ? HiIcons[icon as HiIcon] : MMIcons[icon as MMIcon];

  const iconStyles = tw(
    "shrink-0",
    "transition-all",
    "duration-300",
    color,
    margin
  );

  return (
    <Icon
      {...iconProps}
      strokeWidth={strokeWidth}
      className={`manymoreIcon ${iconStyles}`}
    />
  );
};
